
export default class Subject{
    constructor(){
        this._obervsers = [];
    }
    register(observer){
        this._obervsers.push(observer);
    }
    unRegister(observer){
        let _index = -1;
        for (let index = 0; index < this._obervsers.length; index++) {
            if(this._obervsers[index]._id == observer._id){
                _index = index;
            }
        }
        if(_index != -1){
            this._obervsers.splice(_index,1);
        }
    }
    update(data){
        this._obervsers.forEach(x => {
            x.onUpdate(data);
        });
    }
}